// akhila 11/18/2022 2699234404 integrated get api
// akhila 11/18/2022 2699234404 integrated get api for scheduler
// Rajesh 11/23/2022 2699234404 integrated get api for job execution and post api for copy.
// Poornima 11/30/2022 2699234404 added copy code property
// rajesh 12/05/2022 2699234404 integrated get api for task execution and post download
// Dilip 12/05/2022  2698948956 Removed unecesarry console.log statements
// rajesh 12/15/2022 2699234404 added url for download
// akhila 12/21/2022 2699234404 added jobDataId in get api
// dilip 12/28/2022 2699234404 integrated save api for system notes
// kavyareddy 12/28/2022 2699234404 integrated print api for download configuration
// kavyareddy 12/30/2022 2699234404 integrated download execution api
// kavyareddy 02/2/2023 2699234404 integrated api based on jobexecutioId
// Ashraf 02/02/2023 2699234404 fixed page break issue
// Akhila 02/27/2023 2699234404 implemented preview file functionality in download configuration
// Sohel 03/01/2023 2699234404 Added loader and download toast a message for preview File
// Akhila 03/10/2023 2699234404 Added preview toast message and loader
// Akhila 06/22/2023 2699234404 conditionally disable save and finish button on submission

import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {fetchDownloadSuccess} from '../PreviewFileData';
import {submissionEnd} from '../CommonActions/commonActions';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  addNightJobStatus: null,
  addScheduleJobStatus: null,
  nightJobData: {},
  jobScheduleData: [],
  systemNotesStatus: null,
  isSystemNoteLoading: false,
  addNightJob: null,
  jobDetailsData: {},
  jobDetailsStatus: null,
  taskExecutionData: [],
  allJobCodesAndJobNames: [],
  copyNightJobStatus: null,
  nightJobExecutionData: [],
  jobRunDetailsStatus: null,
  nightTaskExecutionData: [],
  scheduleStatus: null,
  configurationUrl: '',
  dockey: '',
};

const slice = createSlice({
  name: 'addNightJob',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },
    postNightJobData: (state, action) => {
      state.addNightJobStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
    },

    postAddNightJobData: (state, action) => {
      state.addNightJob = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      // state.successMsg = action.payload.response;
      state.jobDataId = action.payload?.response?.jobCode;
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.isSystemNoteLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getJobDetailsData: (state, action) => {
      state.jobDetailsData = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.jobDetailsStatus = action.payload.status;
      state.jobDataId = action.payload?.response?.jobCode;
      // state.successMsg = action.payload.message;
    },
    getJobRunData: (state, action) => {
      // state.jobDetailsData = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.jobRunDetailsStatus = action.payload.status;
      // state.successMsg = action.payload.message;
    },
    getTaskExecutionData: (state, action) => {
      state.taskExecutionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.taskExecutionStatus = action.payload.status;
      state.successMsg = action.payload.message;
    },
    getNightJobData: (state, action) => {
      state.nightJobData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addRuleGroupStatus = action.payload.status;
      state.successMsg = action.payload.message;
    },
    getNightJobExecutionData: (state, action) => {
      state.nightJobExecutionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getNightTaskExecutionData: (state, action) => {
      state.nightTaskExecutionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getAllJobCodesAndJobNames: (state, action) => {
      state.allJobCodesAndJobNames = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getScheduleData: (state, action) => {
      state.jobScheduleData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ?
        action.payload?.data?.message :
        action.payload?.data?.error ?
          action.payload?.data?.error :
          'Something went Wrong';
      state.isLoading = false;
      state.isSystemNoteLoading = false;
    },
    postCopyNightJobData: (state, action) => {
      state.copyNightJobStatus = action.payload?.status;
      state.isLoading = false;
      state.successMsg = action.payload?.message;
      state.errorMsg = null;
      state.copyCode = action.payload?.response?.jobCode;
    },
    setScheduler: (state, action) => {
      state.addNightJobStatus = action.payload.status;
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    setSchedulerExecution: (state, action) => {
      state.addScheduleJobStatus = action.payload.status;
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetSchedulerExecution: (state, action) => {
      state.addScheduleJobStatus = null;
      state.successMsg = null;
      state.isLoading = false;
    },
    fetchCopyError: (state, action) => {
      state.copyErrorMsg = action.payload;
      state.iscopyLoading = false;
    },
    resetStatus: (state, action) => {
      state.addNightJobStatus = null;
      state.addScheduleJobStatus = null;
      state.addNightJob = null;
      state.isLoading = false;
      state.nightJobData = {};
      state.jobScheduleData = [];
      state.systemNotesStatus = null;
      state.isSystemNoteLoading = false;
      state.jobDetailsData = {};
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.jobDetailsStatus = null;
      state.isSystemNoteLoading = false;
      state.addNightJob = null;
      state.jobRunDetailsStatus = null;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.addNightJobStatus = null;
      state.addScheduleJobStatus = null;
      state.nightJobData = {};
      state.isSystemNoteLoading = false;
    },
    resetCopyNightJobData: (state, action) => {
      state.copyNightJobStatus = null;
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
    },
    resetJobExecutionData: (state, action) => {
      state.nightJobExecutionData = [];
      state.isLoading = false;
    },
    resetTaskExecutionData: (state, action) => {
      state.nightTaskExecutionData = [];
      state.isLoading = false;
    },
    resetSystemNotesData: (state) => {
      state.isSystemNoteLoading = false;
      state.systemNotesStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  postNightJobData,
  getNightJobData,
  postSystemNotesData,
  fetchSuccess,
  fetchError,
  resetMessage,
  resetStatus,
  resetData,
  fetchNoteStart,
  getScheduleData,
  postAddNightJobData,
  getJobDetailsData,
  getJobRunData,
  getTaskExecutionData,
  getAllJobCodesAndJobNames,
  postCopyNightJobData,
  fetchCopyError,
  resetCopyNightJobData,
  getNightJobExecutionData,
  resetJobExecutionData,
  resetTaskExecutionData,
  getNightTaskExecutionData,
  resetSystemNotesData,
  setScheduler,
  setSchedulerExecution,
  resetSchedulerExecution,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
} = slice.actions;

export const fetchAllJobCodesAndJobNames = (data) => {
  return (dispatch) => {
    httpGet(`nightJobs/find/all/jobcodeandjobname`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllJobCodesAndJobNames(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postAddNightJob = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`nightJobs/save/jobconfig`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (
          (data?.status === 200 && data?.data?.status === 400) ||
          data?.status === 400 ||
          data?.status === 500
        ) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postAddNightJobData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postNightJob = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`jobs/save/job`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postNightJobData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`jobs/save/nightjobnotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchJobDetails = (jobCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`nightJobs/get/jobconfig/${jobCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getJobDetailsData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchRunJobDetails = (jobCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`schedule/excute/job/${jobCode}`)
      .then((data) => {
        if ((data?.status === 200 && data?.data?.status === 400) || data?.status === 500) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getJobRunData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchTaskExecutionDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`nightJobs/taskExecution/find/${id}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getTaskExecutionData(data.response));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchNightJob = (jobId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`jobs/find/job/${jobId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getNightJobData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchSchedules = (jobCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`schedule/find/schedule/${jobCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getScheduleData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchJobExecution = (jobCode) => {
  return (dispatch) => {
    dispatch(fetchStart());

    httpGet(`nightJobs/getall/execution/${jobCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getNightJobExecutionData(data.response));
          // dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchTaskExecution = (jobExecutionId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`nightJobs/taskExecution/find/${jobExecutionId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getNightTaskExecutionData(data.response));
          // dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postTaskDownload = (payload, postcustomwindowsdata) => {
  return (dispatch) => {
    // dispatch(fetchStart());
    httpPost(`nightJobs/generateurlprintjobexecution`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // download(data?.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(setDockey(payload?.dockey));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postCopyNightJob = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`nightJobs/save/copy/nightjob`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCopyNightJobData(data));
        } else {
          dispatch(fetchCopyError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchCopyError(error.message));
      });
  };
};
export const postSchedulerSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`nightJobs/save/jobnotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postPrintScheduler = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`schedule/print/schedule`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintNightJob({dockey: data?.message}, data));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postPrintNightJob = (payload, postNightJobdata) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`schedule/generateurlschedulerprint`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(setScheduler(postNightJobdata));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(postNightJobdata));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postPrintScheduleJob = (payload, postScheduleJobdata) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`schedule/generateurlschedulerexecution`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(setSchedulerExecution(postScheduleJobdata));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(postScheduleJobdata));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postPrintSchedulerExecution = (jobExecutionId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`schedule/print/schedule/${jobExecutionId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintScheduleJob({dockey: data.message}, data));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetCopyNightJob = () => {
  return (dispatch) => {
    dispatch(resetCopyNightJobData());
  };
};
export const resetJobExecution = () => {
  return (dispatch) => {
    dispatch(resetJobExecutionData());
  };
};
export const resetTaskExecution = () => {
  return (dispatch) => {
    dispatch(resetTaskExecutionData());
  };
};
export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
export const resetSystemNotes = () => {
  return (dispatch) => {
    dispatch(resetSystemNotesData());
  };
};
export const resetSchedulerExecutions = () => {
  return (dispatch) => {
    dispatch(resetSchedulerExecution());
  };
};
